import React from "react";
import { components } from "react-select";
import BrokerAvatar from "../mui/material/BrokerAvatar";
var BrokerOption = function BrokerOption(props) {
  return /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0"
  }, /*#__PURE__*/React.createElement(BrokerAvatar, {
    size: "sm",
    broker: props.data
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 ps-2"
  }, props.data.label)));
};
export default BrokerOption;